// Long-form details for each service. Used by the ServiceDetailModal.
const SERVICE_DETAILS = {
  // ---------- DENTAL ----------
  "smile-makeover": {
    tag: "Signature Plan",
    duration: "2–4 sessions · 10 days",
    price: "Custom-quoted",
    intro:
      "A complete smile transformation choreographed across veneers, whitening, contouring and (if needed) aligners. Designed pixel-by-pixel to your face, lip line and personality.",
    includes: [
      "Digital smile design preview",
      "Mock-up trial before final work",
      "Premium e.max porcelain veneers",
      "In-clinic whitening",
      "Gum reshaping (if indicated)",
    ],
    aftercare: "Avoid hard foods for 48h; soft-bristled brushing; quarterly polish for the first year.",
  },
  "teeth-whitening": {
    tag: "Quick Win",
    duration: "60 minutes",
    price: "From ₹8,000",
    intro: "Professional in-office bleaching that lifts 4–8 shades in a single sitting — safe for enamel, with desensitising support.",
    includes: ["Pre-cleaning polish", "Customised tray fit", "LED-activated bleaching", "Post-treatment desensitiser"],
    aftercare: "Stay away from coffee, red wine and turmeric for 48 hours to lock in the shade.",
  },
  veneers: {
    tag: "Cosmetic Dental",
    duration: "2 sessions · 7–10 days",
    price: "From ₹18,000 / tooth",
    intro: "Ultra-thin, custom-milled e.max or zirconia laminates bonded to the front of teeth — shape, size and shade designed to suit your face.",
    includes: ["3D smile preview", "Mock-up trial", "Premium ceramic veneers", "Precision bonding"],
    aftercare: "Veneers last 10–15 years with normal care; avoid biting nails or opening packaging with teeth.",
  },
  aligners: {
    tag: "Invisible Ortho",
    duration: "6–18 months",
    price: "From ₹1,20,000",
    intro: "Discreet Invisalign-style clear aligners that gently straighten teeth — removable, comfortable, and barely visible.",
    includes: ["3D scan & treatment plan", "Sequential clear trays", "Monthly progress reviews", "Final retainers"],
    aftercare: "Wear aligners 20–22 hrs/day; retain progress with nightly retainers post-treatment.",
  },
  implants: {
    tag: "Restorative",
    duration: "3–6 months",
    price: "From ₹35,000",
    intro: "Permanent titanium implants that replace missing teeth root-and-all — restoring full bite force and a natural-looking smile.",
    includes: ["3D CBCT scan", "Surgical placement", "Custom abutment & crown", "1-year follow-up"],
    aftercare: "Soft diet for the first week; rinse with prescribed mouthwash; quarterly review for the first year.",
  },
  fillings: {
    tag: "Restorative",
    duration: "30–45 minutes",
    price: "From ₹1,500",
    intro: "Tooth-coloured composite restorations that disappear into the natural enamel — strong, aesthetic, mercury-free.",
    includes: ["Cavity assessment", "Layered composite restoration", "Bite calibration & polish"],
    aftercare: "Eat normally after an hour; avoid extremely hot/cold for the first 24h.",
  },
  rct: {
    tag: "Endodontic",
    duration: "1–2 sittings",
    price: "From ₹4,500",
    intro: "Save a severely infected or decayed tooth with a precise, virtually painless single-visit RCT under rotary endodontics.",
    includes: ["Local anaesthesia", "Rotary cleaning & shaping", "Bio-ceramic obturation", "Permanent crown planning"],
    aftercare: "Mild soreness for 24–48h; crown recommended within 2 weeks for long-term protection.",
  },
  crowns: {
    tag: "Prosthetic",
    duration: "2 sessions · 5–7 days",
    price: "From ₹6,000",
    intro: "Custom-crafted zirconia or PFM crowns and bridges that restore damaged or missing teeth — natural in look, strong in function.",
    includes: ["Tooth preparation", "Digital impression", "Shade matching", "Precision cementation"],
    aftercare: "Avoid sticky foods for 24h; crowns last 10–20 years with regular care and check-ups.",
  },
  cleaning: {
    tag: "Preventive",
    duration: "45–60 minutes",
    price: "From ₹1,200",
    intro: "A thorough professional cleaning and dental check-up — scaling, polishing, and a comprehensive oral health assessment.",
    includes: ["Ultrasonic scaling", "Air polishing", "Fluoride application", "Oral health report"],
    aftercare: "Avoid eating for 30 minutes; schedule every 6 months for optimal oral health.",
  },
};

export default SERVICE_DETAILS;
